import { motion } from "framer-motion";
import classNames from "classnames";

interface ButtonProps {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
  roundedClass: string;
  layoutId: string;
  dataTestId?: string;
}

const ToggleButton: React.FC<ButtonProps> = ({
  isActive,
  onClick,
  children,
  roundedClass,
  layoutId,
  dataTestId,
}) => {
  return (
    <button
      data-testid={dataTestId}
      className={classNames(
        "gg-relative gg-w-full gg-border-y gg-border-gray-200 gg-py-2.5 gg-text-xs gg-font-bold gg-transition-all gg-duration-300 gg-ease-in-out hover:gg-bg-gray-100 sm:gg-py-3.5 sm:gg-text-sm",
        roundedClass,
        {
          "gg-text-white": isActive,
          "gg-text-dark-blue": !isActive,
        },
      )}
      onClick={onClick}
    >
      <div className="gg-relative gg-z-10">{children}</div>
      {isActive ? (
        <motion.div
          initial={false}
          className="gg-absolute gg-inset-0 gg-bottom-[1px] gg-left-[1px] gg-right-[1px] gg-top-[1px] gg-bg-dark-blue"
          layoutId={layoutId}
        />
      ) : null}
    </button>
  );
};

export default ToggleButton;
